import React from "react";
import commonStyles from "../../Shared/commonStyles.module.css";
import styles from "./GiftWrapWhy.module.css";

function GiftWrapWhy() {
  return (
    <section className={`${commonStyles.section} ${styles.GiftWrapWhy}`}>
      <h2>Why Are Presents Traditionally Wrapped?</h2>
      <p className={commonStyles.paragraph}>
        Gift wrapping adds an element of surprise and anticipation, while
        protecting the gift and preserving the excitement until the perfect
        moment of unveiling.        
      </p>
      <div className={styles.GiftWrapWhyContent}>
      <img src="/Images/Content/CustomerServices/GiftWrap/Giftwrap-Why.jpg" alt="Giftwrap Why" className={styles.GiftWrapWhyImg} />
      </div>
    </section>
  );
}

export default GiftWrapWhy;
